import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NavigationHistoryService } from '@core/services/navigation-history/navigation-history.service';

@Component({
  selector: 'app-checks-page',
  templateUrl: './checks-page.component.html',
  standalone: false,
})
export class ChecksPageComponent implements OnInit {
  @Input() body: any;
  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly navigationHistoryService: NavigationHistoryService,
  ) {}

  ngOnInit(): void {
    this.navigationHistoryService.pushStateFromActivatedRouteSnapshot(
      'user-check-list',
      this.activatedRoute.snapshot,
    );
  }
}
